import { Event, EventPriceClass } from "components/EventCalendar/types";
import { useMemo } from "react";
import useSWR from "swr";
import { useClubMemberAuthStore } from "../../../ClubMemberManagement/ClubMember/ClubMemberAuthorization";

export const useEventPrice = (
    event: Event,
    email: string | null = null,
    memberId: number | string | null = null
) => {
    const { clubMemberAuthToken } = useClubMemberAuthStore();
    const methods = useSWR<{
        success: boolean;
        data: Array<EventPriceClass & { active?: boolean }>;
    }>(
        event
            ? [
                  `event/${event.id}/prices`,
                  // The member has to travel with the request: the price follows the participant,
                  // not the account that happens to be logged in.
                  {
                      clubMemberAuthToken,
                      ...(email ? { email } : {}),
                      ...(memberId ? { club_member_id: memberId } : {})
                  }
              ]
            : null
    );

    const activePrice: (EventPriceClass & { active?: boolean }) | undefined = useMemo(
        () => methods.data?.data?.find((price) => price.active),
        [methods.data]
    );
    return { activePrice, ...methods };
};
